import React, { createContext, useContext, useState } from 'react';

const langs = ['pl', 'en', 'ua'];
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('pl');
  const toggleLang = () => setLang(prev => langs[(langs.indexOf(prev) + 1) % langs.length]);
  const setLanguage = (l) => setLang(l);
  return (
    <LanguageContext.Provider value={{ lang, toggleLang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
